<div class="modal-header">
	<button type="button" class="close" data-dismiss="modal">×</button>
	<h4 class="modal-title">{{TR "Einstellungen bearbeiten"}}</h4>
</div>
<div class="modal-body">
	<div class="row">
		<div class="col-md-12" id="modal-body">
			{{#if errors.error}}
			<div class="alert alert-danger">{{TR errors.error }}</div>
			{{/if}}

			<div class="form-group">
				<label for="{{el_id}}" class="control-label">{{label}}</label>

				{{#if dropdownItems}}
	                {{#SELECT selectedValue}}
					<select class="form-control select2" id="{{el_id}}-input" name="{{el_id}}">
						{{#each dropdownItems}}
						<option value="{{this.key}}">{{this.value}}</option>
						{{/each}}
					</select>
					{{/SELECT}}
				{{else}}
					<input type="{{type}}" class="form-control" id="{{el_id}}-input" name="{{el_id}}" placeholder="{{label}}" value="{{content}}">
					{{#if hint}}
					<span>
						<small>
							{{hint}}
						</small>
					</span>
					{{/if}}

					{{#if errors.formError}}
					<ul class="parsley-errors-list filled">
						<li class="parsley-required">{{errorPrefix}} {{TR errors.formError}}</li>
					</ul>
					{{/if}}
				{{/if}}
			</div>
		</div>

		<input type="hidden" class="form-control" id="updateType" name="updateType" value="{{updateType}}">

	</div>

	{{#if cur_pass_req}}
	<div class="row">
		<div class="col-md-12">
			<div class="form-group">
				<label for="curPassword" class="control-label">{{TR "Aktuelles Passwort"}}</label>
				<input type="password" class="form-control" id="curPassword-input" name="curPassword" placeholder="{{TR "Aktuelles Passwort"}}" autocomplete="off">
				{{#if errors.pwError}}
				<ul class="parsley-errors-list filled">
					<li class="parsley-required">{{TR "Passwort ist "}}{{TR errors.pwError}}</li>
				</ul>
				{{/if}}
			</div>
		</div>
	</div>
	{{/if}}
</div>
<div class="modal-footer">
	<button id="ct-cancel" type="button" class="btn btn-white" data-dismiss="modal">{{TR "Abbrechen"}}</button>
	<button type="button" class="btn btn-primary" id="js-success">{{TR "Speichern"}}</button>
</div>
